import { ButtonControl } from "./buttonControl"
import styled from "styled-components"
import classNames from "classnames";

const ButtonAddWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: flex-start;

    span:first-child{
        min-width: 40px;
    }

    span.disabled{
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

interface ButtonAddProps {
    onClick?: () => void;
    label: string;
    disabled?: boolean;
    type: "button" | "submit";
}

export const ButtonAdd = (props: ButtonAddProps) => {
    return (
        <ButtonAddWrapper>
            <span>
                <ButtonControl
                    onClick={props.onClick}
                    disabled={props.disabled}
                    type={props.type} 
                    value="+"
                    primary
                    add
                />
            </span>
            <span className={classNames(
                "text sizeSm colorNavi styleBold", {"disabled": props.disabled}
            )}>
                {props.label}
            </span>
        </ButtonAddWrapper>
    )
}